'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Phone } from 'lucide-react';

const navLinks = [
  { label: 'Apartments', href: '/' },
  { label: 'Apartment Detail', href: '/apartment-detail' },
  { label: 'Contact', href: '#contact' },
];

export default function GuestTopbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl text-foreground tracking-tight">
            Vacay<span className="text-primary">Rent</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="px-4 py-2 text-sm font-500 text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-all duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+44 7990 856 358"
            className="flex items-center gap-1.5 text-sm font-500 text-muted-foreground hover:text-secondary transition-colors"
          >
            <Phone size={15} />
            +44 7990 856 358
          </a>
          <Link href="/apartment-detail" className="btn-primary text-sm py-2 px-4">
            Book Now
          </Link>
          <Link
            href="/admin-dashboard"
            className="text-xs text-muted-foreground hover:text-primary transition-colors px-2 py-1 border border-border rounded-lg"
          >
            Owner Login
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-border px-6 py-4 space-y-2 animate-slide-up">
          {navLinks?.map((link) => (
            <Link
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className="block px-4 py-2.5 text-sm font-500 text-foreground hover:bg-muted rounded-lg transition-colors"
            >
              {link?.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-border flex flex-col gap-2">
            <Link href="/apartment-detail" className="btn-primary text-sm py-2.5 justify-center">
              Book Now
            </Link>
            <Link href="/admin-dashboard" className="text-center text-xs text-muted-foreground py-2">
              Owner Login
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}